import React from 'react';
import { IconProps } from '.';

const SvgBookOpenEmpty = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M8.872 3.75c1.22 0 2.32.502 3.126 1.306a4.413 4.413 0 0 1 3.127-1.306h7.625v15.77l-7.78.01h-.006a1.704 1.704 0 0 0-1.24.53l-.742.77a1.363 1.363 0 0 1-1.964 0l-.751-.78a1.705 1.705 0 0 0-1.228-.53l-7.789.01V3.75h7.622Zm6.253 1.5c-.96 0-1.822.473-2.376 1.225v12.44a3.2 3.2 0 0 1 2.219-.886l6.282-.009V5.25h-6.125ZM2.75 18.028l6.288-.008c.825 0 1.614.323 2.211.892V6.475c-.554-.752-1.417-1.225-2.377-1.225H2.75v12.778Z'
      />
    </svg>
  );
};

export default SvgBookOpenEmpty;
